import React, { useEffect, useState } from "react";
import { Button, Label, FormGroup, Form } from "reactstrap";
import { formatDate, formatRP } from "../../../Utils/externalFunctions";
import DataTable from "react-data-table-component";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { STATUS_DATA_TYPE, getStatusData } from "../../../Constant/StatusData";
import { Download, Edit } from "react-feather";
import { Link } from "react-router-dom";
import Select from "react-select";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { filterSearch } from "../../../Utils/FilterItems";
import { getStatusBadge } from "../../../Utils/otherFunctions";
import { useThemeContext } from "../../../Context/ThemeContext";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";

const StepDua = ({
  transaksiList,
  selectedGroupTransaksi,
  selectedUsername,
  formGroupTransaksi,
  userRoleOpt,
  updateCheckbox,
  handleInputUsername,
  pending,
  handlePrev,
  handleNext,
}) => {
  const [filteredTransaksiList, setFilteredTransaksiList] = useState([]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { themeContext } = useThemeContext();

  let savedSelectedRows = [];

  useEffect(() => {
    if (transaksiList) updateFilter(transaksiList, selectedGroupTransaksi);
  }, [selectedGroupTransaksi, transaksiList, filterText]);

  const updateFilter = (transaksiList, selectedGroupTransaksi) => {
    const searchCategories = [
      "diajukan_oleh",
      "dibayarkan_ke",
      "id_transaksi",
      "id_unit_kerja",
      "keterangan",
    ];

    const filteredItems = transaksiList
      .filter(filterGroupTransaksi)
      .filter(filterSearch(searchCategories, filterText));

    setFilteredTransaksiList(filteredItems);
  };
  const filterGroupTransaksi = (item) =>
    item.group_transaksi?.length === 0 ||
    selectedGroupTransaksi.group_transaksi.includes(item.id);

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const handleSelectedRowsChange = (state) => {
    savedSelectedRows = [
      ...state.selectedRows,
      ...transaksiList.filter(
        (item) =>
          !getListOfId(filteredTransaksiList).includes(item.id) &&
          formGroupTransaksi.group_transaksi.includes(item.id)
      ),
    ];
  };

  const getListOfId = (list) => list.map((item) => item.id);

  const rowSelectCriteria = (row) =>
    formGroupTransaksi.group_transaksi.includes(row.id);

  const DaftarColumns = [
    {
      name: <DataTableTitle text={"Kode Transaksi"} />,
      selector: (row) => row.id_transaksi,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"DPSJ"} />,
      selector: (row) => row.id_unit_kerja,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Transaksi"} />,
      selector: (row) => formatDate(row.tanggal_transaksi),
      sortable: true,
      sortFunction: DateSortFunction("tanggal_transaksi"),
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => row.keterangan,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Dibayar Ke"} />,
      selector: (row) => row.dibayarkan_ke,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Diperlukan (Rp)"} />,
      selector: (row) => parseInt(row.nilai_transaksi),
      sortable: true,
      format: (row) => formatRP(row.nilai_transaksi),
    },
    {
      name: <DataTableTitle text={"Dokumen"} />,
      selector: (row) => (
        <Link
          to={`${process.env.PUBLIC_URL}/transaksi/document/${row.id}`}
          target="_blank"
        >
          <Download />
        </Link>
      ),
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Status"} />,
      selector: (row) => {
        const statusData = getStatusData(
          row.id_status_transaksi,
          STATUS_DATA_TYPE.Transaksi
        );
        return getStatusBadge(statusData);
      },
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Operasi"} />,
      selector: (row) => (
        <Link to={`${process.env.PUBLIC_URL}/transaksi/edit/${row.id}`}>
          <Edit color="orange" />
        </Link>
      ),
    },
  ];

  return (
    <>
      <Form>
        <FormGroup>
          <Label for="username" className="bg-transparent">
            Pilih Staf Keuangan
          </Label>
          <Select
            className="basic-single"
            classNamePrefix="select"
            isClearable
            isSearchable
            name="username"
            value={selectedUsername}
            options={userRoleOpt}
            onChange={(e) => {
              updateCheckbox(savedSelectedRows);
              handleInputUsername(e);
            }}
          />
        </FormGroup>
      </Form>
      <Label className="bg-transparent">Transaksi yang sudah dibayar</Label>
      <DataTable
        columns={DaftarColumns}
        data={filteredTransaksiList}
        pagination
        subHeader
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              updateCheckbox(savedSelectedRows);
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        selectableRowsHighlight
        selectableRows
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRowSelected={rowSelectCriteria}
        highlightOnHover
        progressPending={pending}
        persistTableHead
        theme={themeContext}
      />
      <div className="row justify-content-between mt-4">
        <div className="col-auto">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              updateCheckbox(savedSelectedRows);
              handlePrev();
            }}
          >
            Kembali
          </Button>
        </div>
        <div className="col-auto">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              updateCheckbox(savedSelectedRows);
              handleNext();
            }}
          >
            Selanjutnya
          </Button>
        </div>
      </div>
    </>
  );
};

export default StepDua;
